<template>
  <div class="new-form23" v-if="ready">
    <formGenerator  :schema="schema" :model="model" :options="options"></formGenerator>
  </div>
</template>

<script>
  import VueFormGenerator from "vue-form-generator";
  import "vue-form-generator/dist/vfg.css";  // optional core css additions
  import feed from '@/mixins/feed.js'

  export default {
    name: 'newClass',
    components: { "formGenerator": VueFormGenerator.component},
    mixins: [feed],
    props: {

    },
    data: function () {
      return {
          rows: null,
          ready: false,
          t: this.t,
          templates: [],
          model: {
              name: null,
              template: null
          },
        options: {
          validateAfterLoad: true,
          validateAfterChanged: true
        }
      }
    },
    mounted () {
        this.fetchTemplates(2).then(response => {
          response.body.forEach((e) => {
            this.templates.push({name: e.name, id: e.id})
          });
         setTimeout(() => {
           this.ready = true;

           this.schema =  {
             fields: [
               {
                 type: "input",
                 inputType: "text",
                 placeholder: 'Name',
                 model: "name",
                 readonly: false,
                 featured: false,
                 disabled: false
               },
               {
                 type: "select",
                 model: "template",
                 required: true,
                 values: this.templates
               },
               {
                 type: "submit",
                 label: "",
                 buttonText: "Create",
                 onSubmit: this.createClass,
                 validateBeforeSubmit: false,
               }
             ]
           }

           this.getClass();
         }, 1000)
        })
    },
    methods: {
      createClass (d) {
        this.openClass(d).then(response => {
          this.$emit('added', response.body);
        })
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

  .new-form23 .form-group {
    width: 20%;
    padding: 2px;
  }

</style>



// WEBPACK FOOTER //
// src/components/competition/form/newClass.vue